(() => {
  const drawer = document.querySelector('[data-tradepro-cart-drawer]');
  const overlay = document.querySelector('[data-tradepro-cart-overlay]');

  if (!drawer || !overlay) return;

  const setHiddenFocusState = (container, hidden) => {
    if (window.tradeproSetHiddenFocusState) {
      window.tradeproSetHiddenFocusState(container, hidden);
      return;
    }

    container.setAttribute('aria-hidden', hidden ? 'true' : 'false');

    if (hidden) {
      container.setAttribute('inert', '');
    } else {
      container.removeAttribute('inert');
    }
  };

  setHiddenFocusState(drawer, true);

  const itemsContainer = drawer.querySelector('[data-tradepro-cart-items]');
  const footer = drawer.querySelector('[data-tradepro-cart-footer]');
  const subtotalEl = drawer.querySelector('[data-tradepro-cart-subtotal]');
  const totalEl = drawer.querySelector('[data-tradepro-cart-total]');
  const discountsEl = drawer.querySelector('[data-tradepro-cart-discounts]');
  const taxNoteEl = drawer.querySelector('[data-tradepro-cart-tax-note]');
  const subtitleEl = drawer.querySelector('[data-tradepro-cart-subtitle]');
  const cartGoalEl = drawer.querySelector('[data-tradepro-cart-goal]');

  const labels = {
    emptyTitle: drawer.dataset.emptyTitle || '',
    emptyText: drawer.dataset.emptyText || '',
    subtotal: drawer.dataset.subtotalLabel || '',
    total: drawer.dataset.totalLabel || '',
    discount: drawer.dataset.discountLabel || '',
    remove: drawer.dataset.removeLabel || '',
    viewCart: drawer.dataset.viewCartLabel || '',
    itemLabel: drawer.dataset.itemLabel || '',
    itemsLabel: drawer.dataset.itemsLabel || '',
    quantity: drawer.dataset.quantityLabel || '',
    subscription: drawer.dataset.subscriptionLabel || '',
    taxesIncluded: drawer.dataset.taxesIncludedLabel || '',
    each: drawer.dataset.eachLabel || ''
  };

  let lastOpenTrigger = null;

  const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  const endpoint = (path) => rootPath.replace(/\/$/, '/') + path;


  const getTradeProAppSlots = () => Array.from(document.querySelectorAll('[data-tradepro-app-slot]'));

  const updateTradeProCartSlotContext = (cart) => {
    if (!cart) return;

    getTradeProAppSlots().forEach((slot) => {
      if (slot.dataset.tradeproAppContext !== 'cart') return;
      slot.dataset.cartItemCount = String(cart.item_count || 0);
      slot.dataset.cartTotalPrice = String(cart.total_price || 0);
      slot.dataset.cartCurrency = cart.currency || '';
    });
  };

  const dispatchTradeProCartEvent = (name, detail = {}) => {
    const eventName = `tradepro:cart:${name}`;
    const eventDetail = {
      cart: detail.cart || null,
      source: detail.source || 'theme',
      drawer,
      cartDrawer: drawer,
      appSlots: getTradeProAppSlots(),
      ...detail
    };

    document.dispatchEvent(new CustomEvent(eventName, { detail: eventDetail }));
    window.dispatchEvent(new CustomEvent(eventName, { detail: eventDetail }));
  };

  window.tradeproCartDispatchEvent = dispatchTradeProCartEvent;
  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  const formatMoney = (cents, currency = 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
    }
  };

  const formatUnitMeasurement = (measurement = {}) => {
    if (!measurement || !measurement.reference_unit) return '';

    const referenceValue = Number(measurement.reference_value || 1);
    const referencePrefix = referenceValue === 1 ? '' : escapeHTML(referenceValue);

    return `${referencePrefix}${escapeHTML(measurement.reference_unit)}`;
  };

  const renderProperties = (properties = {}) => {
    const visibleProperties = Object.entries(properties).filter(([name, value]) => (
      value && !String(name).startsWith('_')
    ));

    if (!visibleProperties.length) return '';

    return `
      <dl class="tradepro-cart-line__properties">
        ${visibleProperties.map(([name, value]) => `
          <div>
            <dt>${escapeHTML(name)}</dt>
            <dd>${escapeHTML(value)}</dd>
          </div>
        `).join('')}
      </dl>
    `;
  };

  const renderOptions = (item) => {
    const options = Array.isArray(item.options_with_values)
      ? item.options_with_values
      : [];
    const variantTitle = String(item.variant_title || '').trim();
    const normalizeOptionText = (value) => String(value || '').trim().toLowerCase();
    const isShopifyDefaultTitleOption = (option) => (
      normalizeOptionText(option && option.name) === 'title'
      && normalizeOptionText(option && option.value) === 'default title'
    );
    const isShopifyDefaultVariant = (
      normalizeOptionText(variantTitle) === 'default title'
      || (options.length === 1 && isShopifyDefaultTitleOption(options[0]))
    );

    // Shopify creates this technical option for a one-variant product.
    // It is not customer-facing variant information.
    if (isShopifyDefaultVariant) return '';

    const unitHandles = new Set(['ecoestabilizador-kitomasgota', 'ecoestabilizador-con-rodillo-quitar-gotele', 'quitar-gotele-kit-kitomasgota-brico', 'eliminar-gotele-kit-kitomasgota', 'quitar-gotele-plastico']);
    const handle = item.handle || String(item.url || '').split('/products/')[1]?.split(/[?#]/)[0];
    const visibleOptions = options.filter((option) => !isShopifyDefaultTitleOption(option)).map((option) => {
      if (!unitHandles.has(handle)) return option;
      const key = normalizeOptionText(option.name);
      if (key.includes('rasqueta')) return { name: drawer.dataset.scraperWidthLabel, value: `${option.value} mm` };
      if (key.includes('cubo') || handle === 'ecoestabilizador-kitomasgota') return { name: drawer.dataset.packSizeLabel, value: `${option.value} kg` };
      return option;
    });

    if (visibleOptions.length) {
      return `
        <dl class="tradepro-cart-line__options">
          ${visibleOptions.map((option) => `
            <div>
              <dt>${escapeHTML(option.name)}</dt>
              <dd>${escapeHTML(option.value)}</dd>
            </div>
          `).join('')}
        </dl>
      `;
    }

    if (variantTitle) {
      return `<p class="tradepro-cart-line__variant">${escapeHTML(variantTitle)}</p>`;
    }

    return '';
  };

  const renderLineDiscounts = (item, currency) => {
    const allocations = Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : [];

    if (!allocations.length) return '';

    return `
      <ul class="tradepro-cart-line__discounts" role="list">
        ${allocations.map((allocation) => {
          const title = allocation.discount_application && allocation.discount_application.title
            ? allocation.discount_application.title
            : labels.discount;

          return `
            <li>
              <span>${escapeHTML(title)}</span>
              <strong>-${formatMoney(allocation.amount, currency)}</strong>
            </li>
          `;
        }).join('')}
      </ul>
    `;
  };

  const focusDrawerClose = () => {
    window.requestAnimationFrame(() => {
      const closeButton = drawer.querySelector('[data-tradepro-cart-close]');
      if (closeButton && typeof closeButton.focus === 'function') closeButton.focus();
    });
  };

  const openDrawer = async (trigger) => {
    if (trigger && document.contains(trigger)) {
      lastOpenTrigger = trigger;
    }

    document.body.classList.add('tradepro-cart-is-open');
    setHiddenFocusState(drawer, false);
    dispatchTradeProCartEvent('drawer:open', { source: 'drawer', trigger });

    try {
      return await refreshCart('drawer-open');
    } finally {
      focusDrawerClose();
    }
  };

  const closeDrawer = () => {
    document.body.classList.remove('tradepro-cart-is-open');
    setHiddenFocusState(drawer, true);
    dispatchTradeProCartEvent('drawer:close', { source: 'drawer' });

    const trigger = lastOpenTrigger;
    lastOpenTrigger = null;

    if (trigger && document.contains(trigger) && typeof trigger.focus === 'function') {
      window.requestAnimationFrame(() => trigger.focus());
    }
  };

  const fetchCart = async () => {
    const response = await fetch(endpoint('cart.js'), {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error((window.KitomasgotaI18n?.text("Unable to fetch cart") ?? 'Unable to fetch cart'));

    return response.json();
  };

  const updateHeaderCount = (count) => {
    document.querySelectorAll('[data-tradepro-cart-open]').forEach((link) => {
      const badge = link.querySelector('.tpr-cart-count');

      if (!badge) return;

      const normalizedCount = Math.max(0, Number(count) || 0);
      badge.textContent = normalizedCount;
      badge.hidden = normalizedCount === 0;
    });
  };

  const updateCartGoal = (cart) => {
    if (!cartGoalEl) return;

    const threshold = Number(cartGoalEl.dataset.goalCents || 0);
    if (!Number.isFinite(threshold) || threshold <= 0) return;

    const total = Math.max(0, Number(cart.total_price || 0));
    const reached = total >= threshold;
    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, Math.round((total / threshold) * 100));
    const messageEl = cartGoalEl.querySelector('[data-tradepro-cart-goal-message]');
    const progressEl = cartGoalEl.querySelector('[data-tradepro-cart-goal-progress]');

    cartGoalEl.classList.toggle('is-complete', reached);

    if (messageEl) {
      const remainingTemplate = cartGoalEl.dataset.goalRemainingTemplate || '';
      const reachedMessage = cartGoalEl.dataset.goalReached || '';
      messageEl.textContent = reached
        ? reachedMessage
        : remainingTemplate.replace('__amount__', formatMoney(remaining, cart.currency));
    }

    if (progressEl) {
      progressEl.setAttribute('aria-valuenow', String(progress));
      const fill = progressEl.querySelector('span');
      if (fill) fill.style.width = `${progress}%`;
    }
  };

  const renderSummary = (cart) => {
    const currency = cart.currency;
    const itemsSubtotal = cart.items_subtotal_price ?? cart.total_price ?? 0;
    const cartDiscounts = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    subtotalEl.textContent = formatMoney(itemsSubtotal, currency);
    totalEl.textContent = formatMoney(cart.total_price, currency);

    if (discountsEl) {
      discountsEl.innerHTML = cartDiscounts.map((application) => `
        <div class="tradepro-cart-summary__row tradepro-cart-summary__row--discount">
          <span>${escapeHTML(application.title || labels.discount)}</span>
          <span>-${formatMoney(application.total_allocated_amount, currency)}</span>
        </div>
      `).join('');
    }

    if (taxNoteEl) {
      taxNoteEl.hidden = !cart.taxes_included;
      taxNoteEl.textContent = labels.taxesIncluded;
    }
  };

  const renderCart = (cart) => {
    const count = cart.item_count || 0;
    updateHeaderCount(count);
    updateTradeProCartSlotContext(cart);

    if (subtitleEl) {
      subtitleEl.textContent = `${count} ${count === 1 ? labels.itemLabel : labels.itemsLabel}`;
    }

    if (!count) {
      itemsContainer.innerHTML = `
        <div class="tradepro-cart-empty">
          <div>
            <strong>${escapeHTML(labels.emptyTitle)}</strong>
            <p>${escapeHTML(labels.emptyText)}</p>
          </div>
        </div>
      `;

      footer.classList.add('is-hidden');
      return;
    }

    footer.classList.remove('is-hidden');

    itemsContainer.innerHTML = cart.items.map((item) => {
      const currency = cart.currency;
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHTML(item.product_title || item.title)}" loading="lazy">`
        : '';
      const originalLinePrice = Number(item.original_line_price || 0);
      const finalLinePrice = Number(item.final_line_price || 0);
      const hasDiscount = originalLinePrice > finalLinePrice;
      const sellingPlanName = item.selling_plan_allocation
        && item.selling_plan_allocation.selling_plan
        && item.selling_plan_allocation.selling_plan.name
        ? item.selling_plan_allocation.selling_plan.name
        : '';
      const unitMeasurement = formatUnitMeasurement(item.unit_price_measurement);
      const canUpdateQuantity = !item.instructions || item.instructions.can_update_quantity !== false;
      const canRemove = !item.instructions || item.instructions.can_remove !== false;

      return `
        <article class="tradepro-cart-line">
          <a class="tradepro-cart-line__media" href="${item.url}">
            ${image}
          </a>

          <div class="tradepro-cart-line__content">
            <a class="tradepro-cart-line__title" href="${item.url}">
              ${escapeHTML(item.product_title || item.title)}
            </a>

            ${renderOptions(item)}
            ${renderProperties(item.properties)}

            ${sellingPlanName ? `
              <p class="tradepro-cart-line__selling-plan">
                <span>${escapeHTML(labels.subscription)}:</span>
                ${escapeHTML(sellingPlanName)}
              </p>
            ` : ''}

            ${unitMeasurement && item.unit_price != null ? `
              <p class="tradepro-cart-line__unit-price">
                ${formatMoney(item.unit_price, currency)} / ${unitMeasurement}
              </p>
            ` : ''}

            <div class="tradepro-cart-line__price-group">
              ${hasDiscount ? `
                <s class="tradepro-cart-line__price-compare">
                  ${formatMoney(originalLinePrice, currency)}
                </s>
              ` : ''}
              <span class="tradepro-cart-line__price">
                ${formatMoney(finalLinePrice, currency)}
              </span>
              ${Number(item.quantity) > 1 ? `
                <span class="tradepro-cart-line__each">
                  ${formatMoney(item.final_price, currency)} ${escapeHTML(labels.each)}
                </span>
              ` : ''}
            </div>

            ${renderLineDiscounts(item, currency)}

            <div class="tradepro-cart-line__controls">
              ${canUpdateQuantity ? `
                <div class="tradepro-cart-qty" aria-label="${escapeHTML(labels.quantity)}">
                  <button
                    type="button"
                    data-tradepro-cart-change
                    data-line="${escapeHTML(item.key)}"
                    data-quantity="${Math.max(Number(item.quantity) - 1, 0)}"
                    aria-label="${escapeHTML(labels.quantity)}"
                  >−</button>
                  <span>${escapeHTML(item.quantity)}</span>
                  <button
                    type="button"
                    data-tradepro-cart-change
                    data-line="${escapeHTML(item.key)}"
                    data-quantity="${Number(item.quantity) + 1}"
                    aria-label="${escapeHTML(labels.quantity)}"
                  >+</button>
                </div>
              ` : ''}

              ${canRemove ? `
                <button
                  class="tradepro-cart-remove"
                  type="button"
                  data-tradepro-cart-change
                  data-line="${escapeHTML(item.key)}"
                  data-quantity="0"
                >
                  ${escapeHTML(labels.remove)}
                </button>
              ` : ''}
            </div>
          </div>
        </article>
      `;
    }).join('');

    renderSummary(cart);
    updateCartGoal(cart);
  };

  const refreshCart = async (source = 'refresh') => {
    dispatchTradeProCartEvent('refresh:start', { source });

    try {
      const cart = await fetchCart();
      renderCart(cart);
      dispatchTradeProCartEvent('refreshed', { cart, source });
      dispatchTradeProCartEvent('updated', { cart, source });
      return cart;
    } catch (error) {
      dispatchTradeProCartEvent('refresh:error', { source, error });
      throw error;
    }
  };

  const changeLine = async (line, quantity) => {
    dispatchTradeProCartEvent('change:start', { source: 'cart-drawer', line, quantity: Number(quantity) });

    try {
      const response = await fetch(endpoint('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: line,
          quantity: Number(quantity)
        })
      });

      if (!response.ok) throw new Error((window.KitomasgotaI18n?.text("Unable to update cart") ?? 'Unable to update cart'));

      const cart = await response.json();
      renderCart(cart);
      dispatchTradeProCartEvent('change:success', { cart, source: 'cart-drawer', line, quantity: Number(quantity) });
      dispatchTradeProCartEvent('updated', { cart, source: 'cart-drawer', line, quantity: Number(quantity) });
      return cart;
    } catch (error) {
      dispatchTradeProCartEvent('change:error', { source: 'cart-drawer', line, quantity: Number(quantity), error });
      throw error;
    }
  };

  const getFormErrorEl = (form) => form.querySelector('[data-tradepro-cart-form-error]');

  const showFormError = (form, message) => {
    const el = getFormErrorEl(form);
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  };

  const clearFormError = (form) => {
    const el = getFormErrorEl(form);
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  };

  const addFormToCart = async (form, submitter) => {
    // Reentrancy guard: ignore a second trigger (rapid double-click, a
    // duplicate submit event, Enter pressed twice) while a request for this
    // exact form is still in flight, instead of sending /cart/add.js twice.
    if (form.dataset.tradeproSubmitting === 'true') return;
    form.dataset.tradeproSubmitting = 'true';

    const originalText = submitter ? submitter.textContent : '';
    // Snapshot the real cart before doing anything, so an uncertain result
    // later (network error, lost response) can be checked against what
    // actually happened server-side rather than assumed.
    const cartBefore = await fetchCart().catch(() => null);

    if (submitter) {
      submitter.disabled = true;
      submitter.textContent = submitter.dataset.loadingText || (window.KitomasgotaI18n?.text("Adding…") ?? 'Adding…');
    }

    clearFormError(form);

    // Only a genuine, verified increase in item_count counts as "the add
    // already happened" — this is what makes it safe to stop retrying
    // instead of falling back to a second submission (the old behavior,
    // which could add the product twice when the first request had in fact
    // succeeded server-side but the client never saw a clean response).
    const wasAlreadyAdded = async () => {
      const cartAfter = await fetchCart().catch(() => null);
      return !!(cartBefore && cartAfter && cartAfter.item_count > cartBefore.item_count);
    };

    try {
      const formData = new FormData(form);
      dispatchTradeProCartEvent('add:start', { source: 'product-form', form, submitter });

      let response = null;
      let networkError = null;

      try {
        response = await fetch(endpoint('cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
      } catch (error) {
        networkError = error;
      }

      if (networkError) {
        if (!(await wasAlreadyAdded())) {
          // A raw fetch/network exception message (e.g. "Failed to fetch")
          // is never shown to the shopper — it is a browser/JS-level string,
          // not something a customer can act on. Show the connection-
          // specific, localized message instead.
          const safeError = new Error(
            form.dataset.addNetworkErrorLabel || form.dataset.addErrorLabel || (window.KitomasgotaI18n?.text("Unable to add product to cart.") ?? 'Unable to add product to cart.')
          );
          throw safeError;
        }
      } else if (!response.ok) {
        if (!(await wasAlreadyAdded())) {
          // Only a `description` Shopify's own cart API returned (e.g. an
          // out-of-stock reason) is trustworthy to show verbatim. Anything
          // else falls back to the generic localized label — never a raw
          // HTTP status or JS exception string.
          let message = '';

          try {
            const data = await response.clone().json();
            if (data && typeof data.description === 'string' && data.description) {
              message = data.description;
            }
          } catch (parseError) {
            // No JSON body to read — fall back to the generic label below.
          }

          throw new Error(message || form.dataset.addErrorLabel || (window.KitomasgotaI18n?.text("Unable to add product to cart.") ?? 'Unable to add product to cart.'));
        }
      }

      // Either the request reported success, or it reported an unclear
      // result but the cart really did gain the item — either way there is
      // exactly one product added, and openDrawer's own refreshCart reads
      // the authoritative cart state rather than trusting a stale response.
      const cart = await openDrawer(submitter);
      dispatchTradeProCartEvent('add:success', { cart, source: 'product-form', form, submitter });
      dispatchTradeProCartEvent('updated', { cart, source: 'product-form', form, submitter });
    } catch (error) {
      dispatchTradeProCartEvent('add:error', { source: 'product-form', form, submitter, error });
      showFormError(
        form,
        (error && error.message) || form.dataset.addErrorLabel || (window.KitomasgotaI18n?.text("Unable to add product to cart.") ?? 'Unable to add product to cart.')
      );
    } finally {
      delete form.dataset.tradeproSubmitting;

      if (submitter) {
        submitter.disabled = false;
        submitter.textContent = originalText;
      }
    }
  };

  const addItemsToCart = async (items, submitter) => {
    const normalizedItems = Array.isArray(items)
      ? items
        .map((item) => ({
          id: Number(item && item.id),
          quantity: Math.max(1, Number(item && item.quantity) || 1)
        }))
        .filter((item) => Number.isFinite(item.id) && item.id > 0)
      : [];

    if (!normalizedItems.length) {
      throw new Error((window.KitomasgotaI18n?.text("No cart items were supplied.") ?? 'No cart items were supplied.'));
    }

    dispatchTradeProCartEvent('add:start', { source: 'product-cross-sell', items: normalizedItems, submitter });

    const response = await fetch(endpoint('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: normalizedItems })
    });

    if (!response.ok) {
      throw new Error((window.KitomasgotaI18n?.text("Unable to add selected products to cart.") ?? 'Unable to add selected products to cart.'));
    }

    const cart = await openDrawer(submitter);

    dispatchTradeProCartEvent('add:success', { cart, source: 'product-cross-sell', items: normalizedItems, submitter });
    dispatchTradeProCartEvent('updated', { cart, source: 'product-cross-sell', items: normalizedItems, submitter });

    return cart;
  };

  window.tradeproCartAddItems = addItemsToCart;

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-tradepro-cart-open]');
    const closeButton = event.target.closest('[data-tradepro-cart-close]');
    const changeButton = event.target.closest('[data-tradepro-cart-change]');

    if (openButton) {
      event.preventDefault();
      await openDrawer(openButton);
      return;
    }

    if (closeButton || event.target === overlay) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (changeButton) {
      event.preventDefault();
      changeButton.disabled = true;

      try {
        await changeLine(changeButton.dataset.line, changeButton.dataset.quantity);
      } finally {
        changeButton.disabled = false;
      }
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const action = (form.getAttribute('action') || '').toLowerCase();

    if (!action.includes('/cart/add')) return;
    if (!form.matches('[data-tradepro-cart-form]')) return;
    if (form.dataset.tradeproNoAjax === 'true') return;

    event.preventDefault();
    await addFormToCart(form, event.submitter || form.querySelector('[type="submit"]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab' || !document.body.classList.contains('tradepro-cart-is-open')) {
      return;
    }

    const focusable = Array.from(
      drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hasAttribute('hidden'));

    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  refreshCart('initial').catch(() => {});
})();

(() => {
  const getCartPage = () => document.querySelector('[data-tradepro-cart-page]');

  const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  const endpoint = (path) => rootPath.replace(/\/$/, '/') + path;


  const dispatchTradeProCartPageEvent = (name, detail = {}) => {
    if (typeof window.tradeproCartDispatchEvent === 'function') {
      window.tradeproCartDispatchEvent(name, detail);
      return;
    }

    const eventName = `tradepro:cart:${name}`;
    document.dispatchEvent(new CustomEvent(eventName, { detail }));
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  };
  const updateHeaderCount = (count) => {
    document.querySelectorAll('[data-tradepro-cart-open]').forEach((link) => {
      const badge = link.querySelector('.tpr-cart-count');

      if (!badge) return;

      const normalizedCount = Math.max(0, Number(count) || 0);
      badge.textContent = normalizedCount;
      badge.hidden = normalizedCount === 0;
    });
  };

  const setStatus = (page, message) => {
    const status = page.querySelector('[data-tradepro-cart-page-status]');

    if (status) {
      status.textContent = message || '';
    }
  };

  const setBusy = (page, busy) => {
    page.setAttribute('aria-busy', busy ? 'true' : 'false');
    page.classList.toggle('is-updating', busy);

    page.querySelectorAll('[data-tradepro-cart-page-quantity]').forEach((input) => {
      input.disabled = busy;
    });

    page.querySelectorAll('[data-tradepro-cart-page-remove]').forEach((link) => {
      link.setAttribute('aria-disabled', busy ? 'true' : 'false');

      if (busy) {
        link.setAttribute('tabindex', '-1');
      } else {
        link.removeAttribute('tabindex');
      }
    });

    if (busy) {
      setStatus(page, page.dataset.updatingLabel || '');
    }
  };

  const getErrorMessage = async (response, page) => {
    try {
      const data = await response.json();

      if (data && typeof data.description === 'string' && data.description) {
        return data.description;
      }

      if (data && typeof data.message === 'string' && data.message) {
        return data.message;
      }
    } catch (error) {
      return page.dataset.updateErrorLabel || '';
    }

    return page.dataset.updateErrorLabel || '';
  };

  const parseQuantity = (value) => {
    const quantity = Number(value);

    if (!Number.isInteger(quantity) || quantity < 0) {
      return null;
    }

    return quantity;
  };

  const replaceCartPage = (page, sectionHtml, lineKey) => {
    const template = document.createElement('template');
    template.innerHTML = String(sectionHtml || '').trim();

    const nextPage = template.content.querySelector('[data-tradepro-cart-page]');

    if (!nextPage) {
      throw new Error('Cart section response is missing the cart page.');
    }

    page.replaceWith(nextPage);

    if (
      window.Shopify
      && window.Shopify.PaymentButton
      && typeof window.Shopify.PaymentButton.init === 'function'
    ) {
      window.Shopify.PaymentButton.init();
    }

    if (!lineKey) {
      return;
    }

    window.requestAnimationFrame(() => {
      const nextInput = Array.from(
        document.querySelectorAll('[data-tradepro-cart-page-quantity]')
      ).find((input) => input.dataset.lineKey === lineKey);

      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    });
  };

  const changeCartLine = async (input, quantity) => {
    const page = getCartPage();

    if (!page || !input || !input.dataset.lineKey) {
      return;
    }

    const sectionId = page.dataset.sectionId;

    if (!sectionId) {
      return;
    }

    const previousQuantity = input.defaultValue;

    setBusy(page, true);
    dispatchTradeProCartPageEvent('change:start', { source: 'cart-page', line: input.dataset.lineKey, quantity });

    try {
      const response = await fetch(endpoint('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: input.dataset.lineKey,
          quantity,
          sections: [sectionId],
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error(await getErrorMessage(response, page));
      }

      const state = await response.json();
      const sectionHtml = state.sections && state.sections[sectionId];

      if (!sectionHtml) {
        throw new Error(page.dataset.updateErrorLabel || '');
      }

      updateHeaderCount(Number(state.item_count) || 0);
      replaceCartPage(page, sectionHtml, input.dataset.lineKey);
      dispatchTradeProCartPageEvent('change:success', { cart: state, source: 'cart-page', line: input.dataset.lineKey, quantity });
      dispatchTradeProCartPageEvent('updated', { cart: state, source: 'cart-page', line: input.dataset.lineKey, quantity });

      const nextPage = getCartPage();

      if (nextPage) {
        setStatus(nextPage, nextPage.dataset.updatedLabel || '');
      }
    } catch (error) {
      dispatchTradeProCartPageEvent('change:error', { source: 'cart-page', line: input.dataset.lineKey, quantity, error });

      if (document.contains(input)) {
        input.value = previousQuantity;
      }

      setBusy(page, false);
      setStatus(
        page,
        error && error.message
          ? error.message
          : page.dataset.updateErrorLabel || ''
      );
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-tradepro-cart-page-quantity]');

    if (!input) {
      return;
    }

    const quantity = parseQuantity(input.value);

    if (quantity === null) {
      input.value = input.defaultValue;
      return;
    }

    if (String(quantity) === String(input.defaultValue)) {
      return;
    }

    changeCartLine(input, quantity);
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-tradepro-cart-page-quantity]');

    if (!input || event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    input.blur();
  });

  document.addEventListener('click', (event) => {
    const removeLink = event.target.closest('[data-tradepro-cart-page-remove]');

    if (!removeLink) {
      return;
    }

    if (removeLink.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    const page = getCartPage();

    if (!page) {
      return;
    }

    const input = Array.from(
      page.querySelectorAll('[data-tradepro-cart-page-quantity]')
    ).find((field) => field.dataset.lineKey === removeLink.dataset.lineKey);

    if (!input) {
      return;
    }

    event.preventDefault();
    changeCartLine(input, 0);
  });
})();

(() => {
  const labels = document.querySelector('[data-tradepro-cart-drawer]')?.dataset;
  if (!labels?.giftContinueLabel || !labels?.giftChooseLabel) return;
  const prepareGiftChoice = () => {
    const choice = document.getElementById('gift-engine-choice');
    if (!choice || choice.querySelector('[data-km-gift-toggle]')) return;
    try {
      if (sessionStorage.getItem('km-gift-choice-collapsed') === 'true') choice.classList.add('km-gift-collapsed');
    } catch {}
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.dataset.kmGiftToggle = '';
    const updateToggle = () => {
      const collapsed = choice.classList.contains('km-gift-collapsed');
      toggle.textContent = collapsed ? labels.giftChooseLabel : labels.giftContinueLabel;
      toggle.setAttribute('aria-expanded', String(!collapsed));
    };
    toggle.addEventListener('click', () => {
      choice.classList.toggle('km-gift-collapsed');
      try { sessionStorage.setItem('km-gift-choice-collapsed', String(choice.classList.contains('km-gift-collapsed'))); } catch {}
      updateToggle();
    });
    updateToggle();
    choice.prepend(toggle);
  };
  prepareGiftChoice();
  const observer = new MutationObserver(prepareGiftChoice);
  observer.observe(document.body, { childList: true, subtree: true });
})();
